/**
 * Created by LifeSoft on 05/12/17.
 */
import {Component} from '@angular/core';
@Component({
  selector: 'app-login-layout',
  templateUrl: './login-layout.component.html',
})
export class LoginLayoutComponent { }
